import {AlertContextType} from "@contexts/AlertContext.tsx";
import React, {createContext} from "react";

export const AlertContext = createContext<AlertContextType | null>(null);

export const useAlert = () => {
    if (!AlertContext) {
        throw new Error("useAlert must be used within an AlertProvider");
    }
    return React.useContext(AlertContext as React.Context<AlertContextType>);
};
